<template>
  <div class="page-content" v-loading="pageLoading">
    <el-radio-group v-model="language" size="small">
      <el-radio-button :label="0">繁體中文</el-radio-button>
      <el-radio-button :label="1">简体中文</el-radio-button>
      <el-radio-button :label="2">English</el-radio-button>
    </el-radio-group>
    <div class="info-detail">
      <div class="info-header">
        <div v-if="language == 0" class="title">{{titleCH}}</div>
        <div v-if="language == 1" class="title">{{title}}</div>
        <div v-if="language == 2" class="title">{{titleEN}}</div>

        <div v-if="language == 0" class="subinfo">大類別：{{ safetyNameCH }}</div>
        <div v-if="language == 1" class="subinfo">大類別：{{ safetyName }}</div>
        <div v-if="language == 2" class="subinfo">大類別：{{ safetyNameEN }}</div>

        <div v-if="language == 0" class="subinfo">小類別：{{ safetySubclassNameCH }}</div>
        <div v-if="language == 1" class="subinfo">小類別：{{ safetySubclassName }}</div>
        <div v-if="language == 2" class="subinfo">小類別：{{ safetySubclassNameEN }}</div>

        <div class="subinfo" id="publish_time">發佈時間：{{ issueTime }}</div>
        <div class="subinfo">移除時間：{{ limitTime }}</div>
        <div class="subinfo">發佈人員：{{ name }}</div>
      </div>
      <div class="border"/>
      <div>
        <div class="media-block pdf" v-if="file">
          <div class="label">資訊文件</div>
          <div class="pdf-content">
            <el-button type="primary" @click="download">下載
              <i class="el-icon-download el-icon--right"></i>
            </el-button>
            <iframe v-if="file.endsWith('.pdf')" :src="file" class="pdf-preview" width="100%" height="600px"/>
          </div>
        </div>
      </div>
    </div>
    <el-button class="btn"
               @click="$router.back(-1)">返 回</el-button>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css';
import 'videojs-flash';
export default {
  data () {
    return {
      pageLoading: false,

      // 切换语言
      language: 0,

      title: '',
      titleCH: '',
      titleEN: '',
      issueTime: '',
      limitTime: '',
      name: '',
      intro: '',
      introCH: '',
      introEN: '',
      content: '',
      contentCH: '',
      contentEN: '',
      img: [],
      file: '',
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '',
            src: '' //视频url地址
          }
        ],
        // poster: '../../static/image/thumb_1_1380_460_20181009043014983386.jpg', //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },

      safetyNameCH: '',
      safetyName: '',
      safetyNameEN: '',
      safetySubclassNameCH: '',
      safetySubclassName: '',
      safetySubclassNameEN: ''
    };
  },
  mounted () {
    $('#pageHead').text('資訊詳情');
    var id = sessionStorage.getItem('informationId');
    this.pageLoading = true
    this.axios({
      url: '/manage/getManInformation',
      params: {
        id: id
      }
    }).then(res => {
      if (res) {
        let msg = res.result[0];
        this.title = msg.title;
        this.titleCH = msg.titleCH;
        this.titleEN = msg.titleEN;
        this.intro = msg.intro;
        this.introCH = msg.introCH;
        this.introEN = msg.introEN;
        this.name = msg.name;
        this.issueTime = msg.startInfoTime;
        this.limitTime = msg.endInfoTime;
        this.content = msg.content;
        this.contentCH = msg.contentCH;
        this.contentEN = msg.contentEN;
        this.img = msg.pictureFile.split(',');
        this.file = msg.contentFile;
        this.playerOptions.sources[0].src = msg.videoFile;

        this.safetyNameCH = msg.safetyNameCH
        this.safetyName = msg.safetyName
        this.safetyNameEN = msg.safetyNameEN
        this.safetySubclassNameCH = msg.safetySubclassNameCH
        this.safetySubclassName = msg.safetySubclassName
        this.safetySubclassNameEN = msg.safetySubclassNameEN
      }
      this.pageLoading = false
    });
  },
  methods: {
    download () {
      location.href = this.file
    }
  }
};
</script>

<style scoped>
.page-content {
  padding: 0 3%;
}
p {
  color: #999;
}
.border {
  width: 30%;
  margin: 24px auto;
  height: 1px;
  background: #ddd;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.img {
  max-width: 400px;
}
.video-box {
  max-width: 60%;
  margin: auto;
}
.info-detail {

}
.info-header {
  
}
.title {
  margin-top: 12px;
  font-weight: 500;
  font-size: 28px;
  text-align: center;
}
.subinfo {
  color: #999;
  margin-top: 9px;
  text-align: center;
}
.intro {
  margin-top: 18px;
  font-size: 18px;
  text-indent: 42px;
}
.content {
  text-indent: 42px;
  padding: 24px 0;
}
.media-block {
  display: flex;
  margin-bottom: 24px;
}
.media-block .label {
  width: 120px;
  font-weight: 550;
  text-align: right;
  margin-right: 12px;
}
.video-box {
  width: 90%;
}
.pdf-content {
  flex-grow: 100;
}
#publish_time {
  margin-top: 18px;
}
</style>
